import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import ImagesUploader from 'components/ImagesUploader';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as submissionFormActions from 'actions/submissionFormActions';
import FormButtons from 'components/FormButtons';
import InfoLink from '../../components/InfoLink';
import capitalize from 'lodash/capitalize';

class ImagesPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    submissionForm: ImmutablePropTypes.map.isRequired,
    uploadImage: PropTypes.func.isRequired,
    removeImage: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    categories: PropTypes.array.isRequired,
    goToPreviousStep: PropTypes.func.isRequired,
    saveDraft: PropTypes.func.isRequired,
    config: ImmutablePropTypes.map.isRequired,
    publisherLogosEnabled: PropTypes.bool
  };

  state = {
    submissionTried: false,
  }

  formSubmitted = () => {
    this.setState(() => ({ submissionTried: true }));
    const images = this.props.submissionForm.getIn(['data', 'images']);

    if (images.size > 0 || !this.props.config.get('images_required', true) || window.GLOBAL_SKIP_VALIDATIONS) {
      this.props.submitForm('images', this.props.history, {});
    }
  }
  goToPreviousStep = () => this.props.goToPreviousStep('images', this.props.history);

  haveImagesInType(type) {
    const images = this.props.submissionForm.getIn(['data', 'images']);
    return images.findIndex(e => e.get('shape') === type) > -1;
  }
  saveDraft = () => this.props.saveDraft('images');

  render() {
    const imageTypes = ['square', 'landscape', 'portrait'];
    const images = this.props.submissionForm.getIn(['data', 'images']);
    const backendError = this.props.submissionForm.getIn(['data', 'imagesLastError']);

    return (
      <div>
        <FormButtons onPrevious={this.goToPreviousStep} onNext={this.formSubmitted} onSaveDraft={this.saveDraft} />
        <div className="row justify-content-center">
          <div className="col-md-10">
            <Card>
              <div className="card-header">
                <h4>Event Image</h4>
              </div>
              <CardBody>
                <p>
                  <b>Choose a compelling image that brings your event to life</b>
                  <InfoLink link="https://support.evvnt.com/hc/en-us/articles/360020923953"/>
                </p>
                <ul>
                  {imageTypes.map(type =>
                    <li key={`type-${type}`}>
                      {capitalize(type)}
                      {this.haveImagesInType(type) && <i className="ml-2 text-success fa fa-check"></i>}
                    </li>
                  )}
                </ul>
                <p>
                  Supplying a variety of shapes allows us to choose a fitting image for each listing across our network of publishers.
                </p>
                <ImagesUploader
                  images={images}
                  isUploading={this.props.submissionForm.get('isUploading')}
                  onUpload={this.props.uploadImage}
                  onRemove={this.props.removeImage}
                  errorVisible={this.state.submissionTried}
                  backendError={backendError}
                  publisherLogosEnabled={this.props.publisherLogosEnabled}
                />
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return({
    submissionForm: state.submissionForm,
    categories: state.categories,
    config: state.config,
    publisherLogosEnabled: state.config.getIn(['origin_publisher_data', 'promoter_logos'])
  });
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImagesPage);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/SubmissionSteps/ImagesPage.jsx